export default "__VITE_ASSET__c81befd9__"